// Reexportar el modelo RespuestaLlamada desde domain/model
export type { RespuestaLlamada } from 'src/app/domain/model/respuesta-llamada/respuesta-llamada';
import type { RespuestaLlamada } from 'src/app/domain/model/respuesta-llamada/respuesta-llamada';
import type { DireccionCursor, PageResponse } from 'src/app/domain/model/common/page-response.dto';

/**
 * Tipo de datos que retorna el backend (RespuestaLlamadaResponse.java).
 * Se mapea internamente a RespuestaLlamada en el adaptador HTTP.
 */
export interface RespuestaLlamadaBackendResponse {
	nmconsecutivo: number;
	dsrespuesta: string;
	/** 'S' si aplica programar nueva llamada - camelCase del backend */
	snAplicaNuevaLlamada?: string;
	/** Horas a sumar para sugerir próxima llamada */
	nmhorasNuevaLlamada?: number | null;
}

/**
 * Puerto Abstracto: RespuestaLlamadaRepository
 * 
 * Define el contrato para operaciones con Respuestas de Llamada.
 * Migrado del legacy GWT UtilidadesBuscadores.buscarRespuestaLlamada().
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpRespuestaLlamadaRepository (adaptador) lo implementa en infraestructura
 */
export abstract class RespuestaLlamadaRepository {

	/**
	 * Página de respuestas de llamada activas, paginada en el servidor con keyset/cursor
	 * (size obligatorio, máximo 100). El total viene en totalElements de la misma respuesta.
	 * El backend interpreta el filtro: número → código exacto; texto → descripción que contiene.
	 * Legacy: UtilidadesBuscadores.buscarRespuesta() (BusquedaActivity paginado en servidor).
	 * @param filtro Texto de búsqueda (vacío = sin filtro)
	 * @param cursor Cursor opaco de la página actual (null = primera página o LAST)
	 * @param size Tamaño de página
	 * @param direction NEXT | PREVIOUS | LAST
	 */
	abstract buscarPagina(
		filtro: string,
		cursor: string | null,
		size: number,
		direction: DireccionCursor
	): Promise<PageResponse<RespuestaLlamada>>;
}
